import React from 'react';
import OrbBall from '../../../components/OrbBall/OrbBall';

/** Concave notch + curl that caps each corner of the answer card's inner gold frame. */
function FrameCorner({ position }) {
  return (
    <svg className={`orb-frame-corner is-${position}`} viewBox="0 0 30 30" aria-hidden="true">
      <path d="M0 0 L0 23 A23 23 0 0 0 23 0 Z" className="orb-frame-patch" />
      <path d="M4.5 22.5 A18 18 0 0 0 22.5 4.5" />
      <path d="M9 17 Q9 9 17 9" strokeWidth="0.8" />
      <circle cx="10.5" cy="10.5" r="1.3" />
    </svg>
  );
}

export default function Reveal({ loading, error, prophecy, mood, onAskAgain, onShare, onRetry }) {
  return (
    <div className="orb-screen">
      <div className="orb-spacer" />
      <div className="orb-reveal-banner">✦ The Orb Says ✦</div>

      <div className={`orb-reveal-orb${loading ? ' is-working' : ''}`}>
        <OrbBall
          mood={mood}
          size={140}
          thinking={loading}
          intensity={loading ? 3 : 0}
          revealing={!loading && !!prophecy}
          expression={loading ? 'thinking' : prophecy ? 'happy' : 'idle'}
          ariaLabel={loading ? 'The orb is thinking' : 'The orb'}
        />
      </div>

      {loading && <div className="orb-loading">Consulting the cosmos…</div>}

      {!loading && error && (
        <>
          <div className="orb-error">{error}</div>
          <button type="button" className="orb-btn" style={{ marginTop: 18 }} onClick={onRetry}>
            Try Again
          </button>
        </>
      )}

      {!loading && !error && prophecy && (
        <>
          <div className="orb-answer-card">
            <span className="orb-frame" aria-hidden="true" />
            {['tl', 'tr', 'bl', 'br'].map((c) => <FrameCorner key={c} position={c} />)}
            {['top', 'left', 'right'].map((g) => <span key={g} className={`orb-frame-gem is-${g}`} aria-hidden="true" />)}
            <span className="orb-quote is-open" aria-hidden="true">“</span>
            <span className="orb-quote is-close" aria-hidden="true">”</span>

            <p className="orb-answer-text">{prophecy.response}</p>
            <div className="orb-answer-meta">Mood: {prophecy.mood}</div>
          </div>

          <div className="orb-btn-row">
            <button type="button" className="orb-btn orb-btn-ghost" onClick={onAskAgain}>
              Ask Again ↻
            </button>
            <button type="button" className="orb-btn" onClick={onShare}>
              Share Prophecy ↗
            </button>
          </div>
        </>
      )}

      <div className="orb-spacer" />
    </div>
  );
}
